import * as Utils from './_ws/utils';
import * as Config from './_ws/config';
import * as Storage from './_ws/storage';
import * as WsCommandEnum from './_ws/WsCommandEnum';
import * as InputHover from './_app/input-hover';
import * as InputValidation from './_app/input-validation';
import * as InputCheckbox from './_app/input-checkbox';
import * as InputPassword from './_app/input-password';
import * as Toasts from './_app/toasts';
import * as InputFlashMessage from './_app/input-flash-message';
import * as InputCart from './_app/input-cart';
import * as Order from './_app/order';
import * as InputOrderComment from './_app/input-order-comment';
import * as InputOrderDelivery from './_app/input-order-delivery';
import * as InputInvoiceSlider from './_app/input-invoice-slider';
import * as Maps from './_app/maps';
import * as OnChangeSubmit from './_app/on-change-submit';
import * as ProductTileChange from './_app/product-tile-change';
import * as Rating from './_app/rating';
import * as Configurator from "./_app/configurator";
import * as FilterToggle from "./_app/product-pagination";
import * as Swiper from './_app/swiper';
import {PRIVATE_LIST_TO_CART} from "./_ws/WsCommandEnum";

const prolineAppDataKey = Config.getProlineAppDataKey();
window.tryReconnectDisplayLog = false;
/*!
 * WebSocket Connection configuration
 */
const connectWsConn = function () {
    Utils.resetCounter();
    Utils.showChecking();
    window.wsConn = new WebSocket(Utils.generateConnectionString());

    window.wsConn.onmessage = function (e) {
        window.spinner.hide();
        const { msgData, command, data, errors } = Utils.parseIncomingMessageData(e);
        if (typeof errors !== 'undefined') {
            if (Array.isArray(errors)) {
                errors.forEach(function (item) {
                    console.error(item);
                });
            } else {
                console.error(errors);
            }
        }
        Toasts.createToasts(data.messages);

        // noinspection FallThroughInSwitchStatementJS
        switch (command) {
            case WsCommandEnum.CLIENT_APP_DATA:
                Utils.showOnline();
                const token = data.token;
                if (typeof token !== 'undefined') {
                    Config.setConfigKey('token', token);
                    Storage.updateProlineAppData('token', token);
                    wsConnReconnect();
                }
                //add reactions for others data, eg. user-guid, etc.
                break;
            case 'broadcast-message':
                const broadcast = data.broadcast || 'toIgnore';
                if (typeof broadcast !== "undefined") {
                    if (broadcast === 'update-basket-counter') {
                        InputCart.setCartBadge(data.amount || 0);
                    } else if (broadcast === 'show-alert-message') {
                        window.alert(`broadcast-second-message <==> amount: ${(data.amount || 0)}`);
                    }
                }
                break;
            case WsCommandEnum.ADD_COMMENT_NEWS: {
                const modal = $(data.modal);
                const form = modal.find('form');
                const modalContainer = $('#' + modal.attr('id'));
                modalContainer.modal('hide');
                modalContainer.replaceWith(modal);
                InputValidation.validateForms(form);
                InputFlashMessage.bind(modal);
                Rating.bind(modal);
                break;
            }
            case WsCommandEnum.ADD_COMMENT: {
                if (data.messages[0][0] === 'success') {
                    const modal = $(data.modal);
                    const form = modal.find('form');
                    InputHover.applyInputHover(modal);
                    const modalContainer = $('#' + modal.attr('id'));
                    modalContainer.on('hidden.bs.modal', function () {
                        modalContainer.replaceWith(modal);
                        InputValidation.validateForms(form);
                        Rating.bind(modal);
                    });
                    modalContainer.modal('hide');
                    if (typeof data.model !== 'undefined') {
                        const model = $(data.model);
                        const modelContainer = $('#' + model.attr('id'));
                        modelContainer.replaceWith(model);
                    }
                } else {
                    $('a[data-bs-target="#add_review_modal' + data.orderId + '"]').next($('.modal')).hide();
                    const modalContainer = $('a[data-bs-target="#add_review_modal' + data.orderId + '"]').next($('.modal'));
                    modalContainer.modal('hide');
                    $('a[data-bs-target="#add_review_modal' + data.orderId + '"]').next($('.modal')).remove();
                    $('a[data-bs-target="#add_review_modal' + data.orderId + '"]').remove();
                }
                break;
            }
            case WsCommandEnum.NEWSNEES:
            case WsCommandEnum.SALE:
            case WsCommandEnum.SEARCHER:
            case WsCommandEnum.CHANGE_CATEGORY_PRODUCT_AMOUNT:
            case WsCommandEnum.BESTSELLER:
            case WsCommandEnum.CATEGORIES:
            case WsCommandEnum.PRODUCERS:
                {
                    const model = $(data.model);
                    const filters = $(data.filters);
                    const breadcrumbs = $(data.breadcrumbs);
                    const categoryLabel = data.category_label;
                    const categoryLead = $(data.category_lead);
                    const form = model.find('form');
                    if (model.attr('id') === 'productListPanel') {
                        if (window.localStorage.productTileType !== 'undefined' && window.localStorage.productTileType !== null) {
                            model.data('pl-product-list', window.localStorage.productTileType);
                        }
                    }
                    InputHover.applyInputHover(model);
                    InputCheckbox.modernCheckAll(form);
                    const container = $('#' + model.attr('id'));
                    container.siblings('.submit-form-cover').removeClass('d-flex');
                    container.replaceWith(model);
                    const filterContainer = $('#' + filters.attr('id'));
                    filterContainer.replaceWith(filters);
                    const breadcrumbsContainer = $('#' + breadcrumbs.attr('id'));
                    breadcrumbsContainer.replaceWith(breadcrumbs);
                    const categoryLeadContainer = $('#' + categoryLead.attr('id'));
                    categoryLeadContainer.replaceWith(categoryLead);
                    if (categoryLabel !== '') {
                        $('#category-name').text(categoryLabel);
                    }
                    InputValidation.validateForms(form);
                    InputValidation.onChangeSubmit(model);
                    try {
                        model.find('[data-bs-toggle="tooltip"]').tooltip();
                    } catch (e) {
                    }
                    ProductTileChange.bind();
                    reBindPagination();
                    FilterToggle.closeFilterBtn();
                    Swiper.createProdCatSwiper();
                    let stateObj = {
                        paginationReloadRequired: true,
                    };
                    let query = '?';
                    if (data.query.length > 0) {
                        query += data.query;
                    } else {
                        query = '';
                    }
                    if(data.title.length > 0) {
                        $('title').text(data.title);
                    }
                    if(data.seoShortLead.length > 0) {
                        $('.category-short-lead').text(data.seoShortLead);
                    }
                    // krótki lead opisuje całą kategorię — przy aktywnym filtrze znika
                    if (typeof data.hideShortLead === 'boolean') {
                        $('.category-short-lead-container').toggleClass('d-none', data.hideShortLead);
                        $('#category-name').toggleClass('mb-3', !data.hideShortLead && $('.category-short-lead-container').length > 0);
                    }
                    if (data.canonical) {
                        $('link[rel="canonical"]').attr('href', data.canonical);
                        $('meta[property="og:url"]').attr('content', data.canonical);
                    }
                    if (data.robots) {
                        $('meta[name="robots"]').attr('content', data.robots);
                    }
                    break;
                }
            case WsCommandEnum.ARTICLES: {
                const model = $(data.model);
                const container = $('.article-list');
                container.replaceWith(model);
                reBindPagination()
                break;
            }
            case WsCommandEnum.REDIRECT: {
                window.location.replace(data.href);
                break;
            }
            case WsCommandEnum.SUMMARY_ORDER: {
                if (!data.error) {
                    if (!data.invalid) {
                        let model = data.model;
                        $('#order-container').replaceWith(model);
                    } else {
                        if (data.replace) {
                            let model = $(data.model);
                            let form = model.find('form');
                            InputHover.applyInputHover(model);
                            InputCheckbox.modernCheckAll(form);
                            InputPassword.applyShowPass(form);
                            let container = $('#order-container');
                            container.replaceWith(model);
                            InputValidation.validateForms(form);
                            InputFlashMessage.bind(model);
                            InputInvoiceSlider.bind();
                            InputOrderComment.bind();
                            InputOrderDelivery.bind();
                            InputCheckbox.radioIsCompany(model);
                            InputCheckbox.modernRadioFormGroupToggler(model);
                            InputValidation.onChangeSubmit(model);
                            Order.bind();
                            Maps.bind();
                            OnChangeSubmit.bind();
                        }
                    }
                }
                break;
            }
            case WsCommandEnum.ADD_ORDER_PARCEL_LOCKER: {
                const modal = $('#add' + data.typeAddress + "Base0");
                modal.one('hidden.bs.modal', function () {
                    const addressRow = $(data.model).find('#' + data.typeAddress + "BaseRow");
                    $('#' + data.typeAddress + "BaseRow").replaceWith(addressRow);
                    InputValidation.validateForms(addressRow.find('form'));
                    Swiper.createAddressSwiper();
                });
                modal.modal('hide');
                break;
            }
            case WsCommandEnum.CHANGE_PROLINE_OFFICE:
            case WsCommandEnum.CHANGE_ORDER_PAYMENT:
            case WsCommandEnum.CHANGE_ORDER_SHIPMENT: {
                const model = $(data.model).find('#order-container');
                const form = model.find('form');
                InputHover.applyInputHover(model);
                InputCheckbox.modernCheckAll(form);
                InputPassword.applyShowPass(form);
                const container = $('#order-container');
                container.replaceWith(model);
                InputValidation.validateForms(form);
                InputFlashMessage.bind(model);
                InputInvoiceSlider.bind();
                InputOrderComment.bind();
                InputOrderDelivery.bind();
                InputCheckbox.radioIsCompany(model);
                InputCheckbox.modernRadioFormGroupToggler(model);
                InputValidation.onChangeSubmit(model);
                Order.bind();
                Maps.bind();
                OnChangeSubmit.bind();
                InputCart.bind();
                // model.find('[data-row-owl-carousel]').each(function () {
                //     Swiper.createAddressSwiper();
                // });
                Swiper.createAddressSwiper();
                const element = $('[id*="BaseRow"]');
                if ($('.shipmentKind').find('.address-carousel').length === 0 && $('#prolineOfficesForm').length === 0) {
                    $(element[1]).find('.modal').modal('show')
                }
                break;
            }
            case WsCommandEnum.ADD_ORDER_COMMENT: {
                const modal = $(data.modal);
                const form = modal.find('form');
                const container = $('#' + $(modal).attr('id'));
                container.replaceWith(modal);
                InputValidation.validateForms(form);
                // InputValidation.validateForms(form);
                InputFlashMessage.bind(modal);
                InputOrderComment.bind();
                InputValidation.onChangeSubmit(modal);
                OnChangeSubmit.bind();
                break;
            }
            case WsCommandEnum.PRODUCT_ADD_SINGLE:
            case WsCommandEnum.PRODUCT_ADD: {
                $.each(data.urls, function (i, e) {
                    if (i === document.location.pathname) {
                        document.location.href = document.location.origin + e;
                    }
                });
                InputCart.setCartBadge(data.amount || 0);
                const submitButton = $('#' + data.formId).find(':submit');
                submitButton.prop('disabled', false);
                submitButton.html(data.label);
                if (data.productName.length > 0) {
                    $('#' + data.modalId).find('.prod-title .title').text(data.productSelect + ' x ' + data.productName);

                }
                if (data.productPrice.length > 0) {
                    $('#' + data.modalId).find('.prod-value .single').text('za sztukę ' + data.productPrice);
                }
                if (data.sumPrice.length > 0) {
                    $('#' + data.modalId).find('.prod-value .sum').text(data.sumPrice);
                }

                if (data.formId.length > 0 && data.newTail.length > 0) {
                    const newTail = $(data.newTail);
                    const form = newTail.find('form');
                    $('#' + data.formId).closest('a').replaceWith(newTail);
                    InputValidation.validateForm(form);
                }

                InputCart.setCartBadge(data.amount || 0);
                InputCart.setCartPrice(data.cartSum || 'Koszyk');
                InputCart.bind();
                $('#' + data.modalId).modal('show');
                break;
            }
            case WsCommandEnum.PRIVATE_LIST_TO_CART: {
                InputCart.setCartBadge(data.amount || 0);
                InputCart.setCartPrice(data.cartSum || 'Koszyk');
                InputCart.bind();
                break;
            }
            case WsCommandEnum.CONFIGURATOR_ASSEMBLY:
                window.location.href = data.href;
                break;
            case WsCommandEnum.CONFIGURATOR_SIMPLY_URL:
                $('#configuratorLink span.url').text(data.url);
                $('#configuratorLink').modal('show');
                $('#configuratorLink button.copy').on('click', function () {
                    navigator.clipboard.writeText(data.url);
                })
                break;
            case WsCommandEnum.CONFIGURATOR:
                $('.price-sum').text(data.sum);
                const tile = $(data.model);
                const tileForm = tile.find('form');
                InputHover.applyInputHover(tile);
                InputCheckbox.modernCheckAll(tileForm);
                InputPassword.applyShowPass(tileForm);
                const tileId = $(tile).attr('id')
                const tileContainer = $('#' + tileId);
                tileContainer.replaceWith(tile);
                InputValidation.validateForms(tileForm);
                InputFlashMessage.bind(tile);
                InputCart.bind();
                InputCart.setCartBadge(data.amount || 0);
                const products = $(data.products);
                products.find('form').each(function (i, e) {
                    let f = $(e);
                    InputValidation.validateForms(f);
                });
                const container2 = $('#' + products.attr('id'));
                container2.replaceWith(products);
                reBindPagination();
                Configurator.bind();
                FilterToggle.openFilterBtn();
                FilterToggle.closeFilterBtn();
                ProductTileChange.bind();

                if (data.scroll === 1) {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $("#choose").offset().top - 70
                    }, { duration: 200 });
                } else if (data.amount < 1) {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $("#" + tileId).offset().top - 150
                    }, { duration: 200 });
                }
                break;
            case WsCommandEnum.CONFIGURATOR_OPTIONAL:
                $('.price-sum').text(data.sum);
                const tile1 = $(data.model);
                const tileForm1 = tile1.find('form');
                InputHover.applyInputHover(tile1);
                InputCheckbox.modernCheckAll(tileForm1);
                InputPassword.applyShowPass(tileForm1);
                const tileId1 = $(tile1).attr('id')
                const tileContainer1 = $('#' + tileId1);
                tileContainer1.replaceWith(tile1);
                InputValidation.validateForms(tileForm1);
                InputFlashMessage.bind(tile1);
                InputCart.bind();
                InputCart.setCartBadge(data.amount || 0);
                const products1 = $(data.products);
                products1.find('form').each(function (i, e) {
                    let f = $(e);
                    InputValidation.validateForms(f);
                });
                const container3 = $('#' + products1.attr('id'));
                container3.replaceWith(products1);
                reBindPagination();
                Configurator.bind();
                FilterToggle.openFilterBtn();
                FilterToggle.closeFilterBtn();

                if (data.scroll === 1) {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $("#choose").offset().top - 70
                    }, { duration: 100 });
                } else if (data.amount < 1) {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $("#" + tileId1).offset().top - 150
                    }, { duration: 100 });
                }

                ProductTileChange.bind();
                break;
            case WsCommandEnum.CART_CLEAN:
            case WsCommandEnum.CART_ADD_PROMO:
            case WsCommandEnum.PRODUCT_REMOVE:
            case WsCommandEnum.PRODUCT_CHANGE:
                const basket = $(data.basket);
                const form = basket.find('form:not([onsubmit="return false"])');
                InputHover.applyInputHover(basket);
                InputCheckbox.modernCheckAll(form);
                InputPassword.applyShowPass(form);
                const basketContainer = $('#' + basket.attr('id'));
                basketContainer.replaceWith(basket);
                InputValidation.validateForms(form);
                InputFlashMessage.bind(basket);
                const assembly = $(data.assembly);
                const assemblyForm = assembly.find('form:not([onsubmit="return false"])');
                InputHover.applyInputHover(assembly);
                InputCheckbox.modernCheckAll(assemblyForm);
                const assemblyContainer = $('#assemblyProducts .modal-tab-row');
                assemblyContainer.replaceWith(assembly);
                InputValidation.validateForms(assemblyForm);
                InputFlashMessage.bind(assembly);
                InputCart.bind();
                InputCart.setCartBadge(data.amount || 0);
                InputCart.setCartPrice(data.cartSum || 'Koszyk');
                InputCart.rangeSliderJs();
                InputCart.installmentCalculation();
                Swiper.bind();
                break;
            case WsCommandEnum.ADD_PRIORITY:
                const box = $(data.model);
                const boxContainer = $('.block-container.order-summary.order-summary-container');
                if (data.priorityShipment === 0) {
                    $('#priorityShipment').prop('checked', false);
                } else {
                    $('#priorityShipment').prop('checked', true)
                }
                boxContainer.replaceWith(box);
                InputCart.bind();
                Order.bind();
                break;
            case WsCommandEnum.CART_FROM_LIST:
                InputCart.setCartBadge(data.amount || 0);

                $.each(data.urls, function (ixde, e) {
                    if (e === document.location.pathname) {
                        document.location.reload();
                    }
                });
                break;
            case WsCommandEnum.RECOMMENDED_PRODUCTS_TO_CART:
                InputCart.setCartBadge(data.amount || 0);

                $.each(data.urls, function (ixde, e) {
                    if (e === document.location.pathname) {
                        document.location.reload();
                    }
                });
                break;
            case WsCommandEnum.LIST_DELETE_PRODUCT: {
                $.each(data.urls, function (ixde, e) {
                    if (ixde === document.location.pathname) {
                        document.location.href = document.location.origin + e;
                    }
                });
                const assembly = $(data.model);
                const assemblyForm = assembly.find('form');

                assemblyForm.each(function (xd, f) {
                    InputCheckbox.modernCheckAll(f);
                })
                InputHover.applyInputHover(assembly);
                const assemblyContainer = $('#listContainer');
                assemblyContainer.replaceWith(assembly);
                InputValidation.validateForms(assemblyForm);
                InputFlashMessage.bind(assembly);
                InputCart.bind();
                break;
            }
            case WsCommandEnum.SERVICE_ADD: {
                const basket = $(data.basket);
                const assembly = $(data.assembly);
                const basketForm = basket.find('form');
                InputHover.applyInputHover(basket);
                InputCheckbox.modernCheckAll(basketForm);
                const basketContainer = $('#' + basket.attr('id'));
                basketContainer.replaceWith(basket);
                InputValidation.validateForms(basketForm);
                InputFlashMessage.bind(basket);

                const assemblyForm = assembly.find('form');
                InputHover.applyInputHover(assembly);
                InputCheckbox.modernCheckAll(assemblyForm);
                const assemblyContainer = $('#assemblyProducts .modal-tab-row');
                if (assembly.find('a').length === 0) {
                    $('#assemblyProducts').modal('hide');
                }
                assemblyContainer.replaceWith(assembly);
                InputValidation.validateForms(assemblyForm);
                InputFlashMessage.bind(assembly);

                InputCart.bind();
                Swiper.bind();
                InputCart.setCartBadge(data.amount || 0);
                break;
            }
            case WsCommandEnum.REGISTER_STAGE2: {
                $(window).scrollTop(0);
            }
            case WsCommandEnum.REGISTER_NIP: {
                const model = $(data.model);
                const form = model.find('form');
                InputHover.applyInputHover(model);
                InputCheckbox.modernCheckAll(form);
                InputPassword.applyShowPass(form);
                const container = $('#register-wholesaler-container');
                container.replaceWith(model);
                InputValidation.validateForm(form);
                break;
            }
            case WsCommandEnum.PERSONALIZATION: {
                const model = $(data.model);
                $('#' + model.attr('id')).replaceWith(model);
                InputValidation.validateForm(model);
                break;
            }
            case WsCommandEnum.CONSENTS: {
                const model = $(data.model);
                InputCheckbox.modernCheckAll(model);
                $('#' + model.attr('id')).replaceWith(model);
                InputValidation.validateForm(model);
                break;
            }
            case WsCommandEnum.CHANGE_PASSWORD: {
                if (data.passwordChanged) {
                    window.location.href = '/wyloguj';
                }
                const model = $(data.model);
                InputHover.applyInputHover(model);
                InputPassword.applyShowPass(model);
                $('#' + model.attr('id')).replaceWith(model);
                InputValidation.validateForm(model);
                break;
            }
            case WsCommandEnum.CHANGE_EMAIL: {
                if (data.emailChanged) {
                    window.location.href = '/wyloguj';
                }
                const model = $(data.model);
                InputHover.applyInputHover(model);
                $('#' + model.attr('id')).replaceWith(model);
                InputValidation.validateForm(model);
                break;
            }
            case WsCommandEnum.CHANGE_ACCOUNT_DATA: {
                const model = $(data.model);
                InputHover.applyInputHover(model);
                $('#' + model.attr('id')).replaceWith(model);
                InputValidation.validateForm(model);
                break;
            }
            case WsCommandEnum.SET_PRIMARY_ADDRESS:
            case WsCommandEnum.DELETE_ADDRESS: {
                const addressRow = $(data.addressRow);
                const editRow = $(data.editRow);
                const editRowForms = editRow.find('form');
                $('#' + addressRow.attr('id')).replaceWith(addressRow);
                InputValidation.validateForms(addressRow.find('form'));
                Swiper.createAddressSwiper();
                InputHover.applyInputHover(editRowForms);
                InputCheckbox.radioIsCompany(editRow);
                InputCheckbox.modernRadioFormGroupToggler(editRow);
                $('#' + editRow.attr('id')).replaceWith(editRow);
                InputValidation.validateForms(editRowForms);
                break;
            }
            case WsCommandEnum.EDIT_ADDRESS: {
                if (data.errorModal) {
                    const model = $(data.model);
                    InputHover.applyInputHover(model);
                    InputCheckbox.radioIsCompany(model);
                    InputCheckbox.modernRadioFormGroupToggler(model);
                    $('#' + model.attr('id')).replaceWith(model);
                    InputValidation.validateForm(model);
                    break;
                }
                const modal = $('#' + data.modalId);
                modal.one('hidden.bs.modal', function () {
                    const addressRow = $(data.addressRow);
                    const editRow = $(data.editRow);
                    const editRowForms = editRow.find('form');
                    $('#' + addressRow.attr('id')).replaceWith(addressRow);
                    InputValidation.validateForms(addressRow.find('form'));
                    Swiper.createAddressSwiper();
                    InputHover.applyInputHover(editRowForms);
                    InputCheckbox.radioIsCompany(editRow);
                    InputCheckbox.modernRadioFormGroupToggler(editRow);
                    $('#' + editRow.attr('id')).replaceWith(editRow);
                    InputValidation.validateForms(editRowForms);
                });
                modal.modal('hide');
                break;
            }
            case WsCommandEnum.ADD_ADDRESS_ORDER:
            case WsCommandEnum.ADD_ADDRESS: {
                const model = $(data.model);
                InputHover.applyInputHover(model);
                InputCheckbox.radioIsCompany(model);
                InputCheckbox.modernRadioFormGroupToggler(model);
                $('#' + model.attr('id')).replaceWith(model);
                InputValidation.validateForm(model.find('form'));
                InputValidation.inputsMask();
                if (!data.errorModal) {
                    const modal = $('#' + data.modalId);
                    modal.one('hidden.bs.modal', function () {
                        const addressRow = $(data.addressRow);
                        const editRow = $(data.editRow);
                        const editRowForms = editRow.find('form');
                        $('#' + addressRow.attr('id')).replaceWith(addressRow);
                        InputValidation.validateForms(addressRow.find('form'));
                        Swiper.createAddressSwiper();
                        InputHover.applyInputHover(editRowForms);
                        InputCheckbox.radioIsCompany(editRow);
                        InputCheckbox.modernRadioFormGroupToggler(editRow);
                        $('#' + editRow.attr('id')).replaceWith(editRow);
                        InputValidation.validateForms(editRowForms);
                    });
                    modal.modal('hide');
                }
                break;
            }
            case WsCommandEnum.ADD_PARCELLOCKER: {
                if (!data.errorModal) {
                    const modal = $('#' + data.modalId);
                    modal.one('hidden.bs.modal', function () {
                        const addressRow = $(data.addressRow);
                        const editRow = $(data.editRow);
                        const editRowForms = editRow.find('form');
                        $('#' + addressRow.attr('id')).replaceWith(addressRow);
                        InputValidation.validateForms(addressRow.find('form'));
                        Swiper.createAddressSwiper();
                        InputHover.applyInputHover(editRowForms);
                        InputCheckbox.radioIsCompany(editRow);
                        InputCheckbox.modernRadioFormGroupToggler(editRow);
                        $('#' + editRow.attr('id')).replaceWith(editRow);
                        InputValidation.validateForms(editRowForms);
                    });
                    modal.modal('hide');
                }
                break;
            }
            case WsCommandEnum.DEFAULT_SHIPMENT: {
                const shipmentModel = $(data.shipmentModel);
                InputValidation.onChangeSubmit(shipmentModel);
                const shipmentContainer = $('#' + shipmentModel.attr('id'));
                try {
                    shipmentContainer.find('[data-bs-toggle="tooltip"]').tooltip('dispose');
                } catch (e) {
                }
                shipmentContainer.replaceWith(shipmentModel);
                try {
                    shipmentModel.find('[data-bs-toggle="tooltip"]').tooltip();
                } catch (e) {
                }
                InputValidation.validateForm(shipmentModel);
                shipmentModel.closest('.custom-main-title').find('.submit-form-cover').removeClass('d-flex');
                const paymentModel = $(data.paymentModel);
                InputValidation.onChangeSubmit(paymentModel);
                $('#' + paymentModel.attr('id')).replaceWith(paymentModel);
                InputValidation.validateForm(paymentModel);
                break;
            }
            case WsCommandEnum.DEFAULT_PAYMENT: {
                const model = $(data.model);
                InputValidation.onChangeSubmit(model);
                $('#' + model.attr('id')).replaceWith(model);
                InputValidation.validateForm(model);
                model.closest('.custom-main-title').find('.submit-form-cover').removeClass('d-flex');
                break;
            }
            case WsCommandEnum.DEFAULT_AMOUNT: {
                const model = $(data.model);
                InputValidation.onChangeSubmit(model);
                InputHover.applyInputHover(model);
                $('#' + model.attr('id')).replaceWith(model);
                InputValidation.validateForm(model);
                break;
            }
            case WsCommandEnum.DEFAULT_SORTING: {
                const model = $(data.model);
                InputValidation.onChangeSubmit(model);
                InputHover.applyInputHover(model);
                $('#' + model.attr('id')).replaceWith(model);
                InputValidation.validateForm(model);
                break;
            }
            case WsCommandEnum.CART_SAVE_CHANGE_NAME: {
                if (data.label.length > 0) {
                    $('#' + data.guid + ' h2').text(data.label)
                }
                $('#savedCart' + data.guid).modal('hide');
                break;
            }
            case WsCommandEnum.CART_SAVE: {
                $('#savedCart').modal('hide');
                window.location.href = data.urls[0];
                break;
            }
            case WsCommandEnum.TOKEN_EXPIRED: {
                window.location.href = '/wyloguj';
                break;
            }
            case WsCommandEnum.RELOAD: {
                window.location.reload();
                break;
            }
            case WsCommandEnum.SWITCH_CUSTOMER: {
                window.location.reload();
                // Utils.sendNewCommandMessage(WsCommandEnum.RELOAD, {});
                break;
            }
            case WsCommandEnum.SEND_QUESTION: {
                $('#productQuestion').modal('hide');
                $('#productQuestion input, #productQuestion textarea').each(function (i, e) {
                    $(e).removeClass('is-valid');
                })
                break;
            }
            case WsCommandEnum.ORDERS_FILTERING: {
                const modal = $(data.modal);
                const container = $('#' + modal.attr('id'));
                container.replaceWith(modal);
                Order.bind();
                Order.filters();
                InputValidation.validateForm(modal.find('form#ordersStatusForm'));
            }
            case WsCommandEnum.BUG_REPORT:
            case WsCommandEnum.DELIVERY_NOTIFICATION: {
                const form = $(data.model);
                const container = $('#' + form.attr('id'));
                container.replaceWith(form);
                InputValidation.validateForm(form);
                $('#' + form.attr('id')).closest('.modal').modal('hide');
                break;
            }
            case WsCommandEnum.DESCRIPTION_ERROR_NOTE: {
                    $('#productQuestionForm #id_of-email-element').val('');
                    $('#productQuestionForm #id_of-note-element').text('');
                    $('#productQuestionForm').closest('.modal').modal('hide');
                break;
            }
            case 'server-debug':
            case 'server-error':
                //messages supported by Utils.parseIncomingMessageData
                break;
            default:
                //do nothing, temporary dump eventObject only
                break;
        }
        window.spinner.hideSubmitStatus();
        window.spinner.hide();
    };
    window.wsConn.onclose = function (e) {
        Utils.showOffline();
        if (!window.tryReconnectDisplayLog) {
            console.log('wsConn.onclose', e);
        }
        tryReconnectWithDelay();
    };
    window.wsConn.onerror = function (e) {
        Utils.showOffline();
        if (!window.tryReconnectDisplayLog) {
        }
        if (!Utils.isWebsocketReady()) {
            $("[data-ws-dependent]").each(function () {
                $(this).removeClass('d-none');
            });
        }
    };

    Utils.waitForSocketConnection(() => {
        window.tryReconnectDisplayLog = false;
        Storage.loadProlineAppData();

        Utils.showOnline();
        Utils.sendNewCommandMessage(WsCommandEnum.CLIENT_APP_DATA, Config.getProlineAppData());
    });
};

const tryReconnectWithDelay = () => {
    window.tryReconnectDisplayLog = true;
    setTimeout(() => {
        if (!Utils.isWebsocketReady()) {
            Storage.loadProlineAppData();
            connectWsConn();
        }
    }, 2000);
};

const wsConnReconnect = function () {
    const oldConnectionString = Config.getConnectionString();
    const newConnectionString = Utils.generateConnectionString();
    if (oldConnectionString !== newConnectionString) {
        let oldWsConn = window.wsConn;
        oldWsConn.onopen = function () {
            oldWsConn.close();
        };
        oldWsConn.onclose = function () {
            oldWsConn = null;
        };
        if (oldWsConn.readyState === 1) {
            oldWsConn.close();
        }
        connectWsConn();
    }
}

const reBindPagination = () => {
    if ('PaginationBind' in window && typeof window.PaginationBind === 'function') {
        window.PaginationBind();
    }
};

$(document).ready(function () {
    Storage.loadProlineAppData();
    connectWsConn();
});

/*!
 * listener for changing of localStorage Data for key prolineAppDataKey
 * load data and send message to server
 */
window.addEventListener('storage', function (e) {
    if (e.key === prolineAppDataKey) {
        Storage.loadProlineAppData();
        wsConnReconnect();
    }
});
